import React from 'react';
import './ModalTabs.css';

export type ModalTabItem<T extends string = string> = {
  key: T;
  label: string;
  icon?: React.ReactNode;
  onSelect?: () => void;
};

const ModalTabs = <T extends string>({
  activeKey,
  items,
  onChange,
}: {
  activeKey: T;
  items: ModalTabItem<T>[];
  onChange: (key: T) => void;
}) => (
  <div className="modal-tabs">
    <div className="modal-tabs__list" role="tablist" aria-orientation="horizontal">
      {items.map((item) => {
        const isActive = item.key === activeKey;
        return (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`modal-tabs__tab ${isActive ? 'is-active' : ''}`}
            onClick={() => {
              onChange(item.key);
              item.onSelect?.();
            }}
          >
            {item.icon && (
              <span aria-hidden="true" className="modal-tabs__icon">
                {item.icon}
              </span>
            )}
            <span className="modal-tabs__label">{item.label}</span>
            <span aria-hidden="true" className="modal-tabs__underline" />
          </button>
        );
      })}
    </div>
  </div>
);

export default ModalTabs;